import fp from 'lodash/fp'

const nestedJSONParse = fp.pipe(fp.unescape, JSON.parse, (item) => {
  if (typeof item === 'string') {
    return JSON.parse(item)
  }
  return item
})

export default nestedJSONParse
